import axios from 'axios';
import qs from 'qs';
// 导入进度条包的js和css
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

import {
  Message
} from 'element-ui';
import store from '../store';

// 获取当前环境根地址
var url = '';
if(process.env.NODE_ENV==='production'){
  url = process.env.VUE_APP_BASE_URL;
}
// 配置全局baseURL
const Axios = axios.create({
  baseURL: url,
  timeout: 50 * 1000, // 请求超时时间
  withCredentials: false
});

// 用于根据当前请求的信息，生成请求 Key
function generateReqKey(config) {
  const { method, url, params, data } = config;
  return [method, url, qs.stringify(params), qs.stringify(data)].join('&');
}

// 用于把当前请求信息添加到pendingRequest对象中
const pendingRequest = new Map();

function addPendingRequest(config) {
  const requestKey = generateReqKey(config);
  config.cancelToken =
    config.cancelToken ||
    new axios.CancelToken((cancel) => {
      if (!pendingRequest.has(requestKey)) {
        pendingRequest.set(requestKey, cancel);
      }
    });
}

// 检查是否存在重复请求，若存在则取消已发的请求
function removePendingRequest(config) {
  const requestKey = generateReqKey(config);
  if (pendingRequest.has(requestKey)) {
    const cancelToken = pendingRequest.get(requestKey);
    cancelToken(requestKey);
    pendingRequest.delete(requestKey);
  }
}

// 请求拦截器
// 在request拦截器中展示进度条 NProgess.start()
Axios.interceptors.request.use(
  (config) => {
    // 添加当前请求进入当前页面的请求数组中 用于路由跳转拦截请求
    config.cancelToken = new axios.CancelToken(function (cancel) {
      store.commit('pushToken',{ cancelToken:cancel });
    });
    removePendingRequest(config); // 检查是否存在重复请求，若存在则取消已发的请求
    addPendingRequest(config); // 把当前请求信息添加到pendingRequest对象中
    // 展示进度条
    NProgress.start();
    if (sessionStorage.getItem('Authorization')) {
      config.headers.Authorization =
        window.sessionStorage.getItem('Authorization');
    }
    // 在最后必须return config 固定写法
    return config;
  },
  (error) => {
    NProgress.done();
    return Promise.reject(error);
  }
);

// 自定义message格式
let _Message = function (msg){
  return Message.error({
    message:msg,
    duration:1000
  });
};
// 响应拦截器
Axios.interceptors.response.use(
  (response) => {
    // 对响应数据做一些事情
    removePendingRequest(response.config); // 从pendingRequest对象中移除请求
    // 隐藏进度条
    NProgress.done();
    return response;
  },
  (error) => {
    // 请求错误时做些事
    NProgress.done();
    // 隐藏进度条
    let status = '';
    if (error.request) {
      status = error.request;
    } else if (error.response) {
      status = error.response;
    }
    if (status) {
      switch (status.status) {
      case 400:
        // error.message = '请求错误(400)';
        _Message('请求错误(400)');
        break;
      case 401:
        _Message('未授权，请重新登录(401)');
        // router.push('/401');
        break;
      case 403:
        _Message('拒绝访问(403)');
        break;
      case 404:
        _Message('请求错误(404)');
        // router.push('/404');
        break;
      case 408:
        _Message('请求错误(408)');
        break;
      case 500:
        _Message( '服务器错误(500)');
        break;
      case 501:
        _Message( '服务未实现(501)');
        break;
      case 502:
        _Message( '网络错误（502）');
        break;
      case 503:
        _Message('服务不可用(503)');
        break;
      case 504:
        _Message('网络超时(504)');
        break;
      case 505:
        _Message('HTTP版本不受支持(505)');
        break;
      default:
        _Message(`连接出错(${error.response.status}`);
      }
    } else {
      // _Message(`连接服务器失败或请求重复${status}`);
    }
    // return Promise.reject(error);
    removePendingRequest(error.config || {}); // 从pendingRequest对象中移除请求
    // 捕获请求被阻止之后的错误
    if(axios.isCancel(error)){
      NProgress.done();
      return new Promise(()=>{});
    }else{
      NProgress.done();
      return Promise.reject(error);
    }
  }
);

// 导出Axios
export default Axios;